import React, { useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { Drawer, List, ListItem, ListItemButton, ListItemText, Divider } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { motion } from 'framer-motion';
import { usePathname } from 'next/navigation';

const MobileHeader = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [product, IsOpen] = useState(false);
  const [ApiDrop, setDropApi] = useState(false);
  const [useCasesDrop, setUseCasesDrop] = useState(false);
  const [industriesDrop, setIndustriesDrop] = useState(false);
  const [products, setProductsDrop] = useState(false);

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setIsDrawerOpen(open);
  };

  const pathname = usePathname();
  React.useEffect(() => {
    setIsDrawerOpen(false);
  }, [pathname]);

  const linkVariants = {
    hidden: { opacity: 0, x: -20 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: i * 0.1,
      },
    }),
  };

  return (
    <div className="flex justify-between items-center px-4 py-4 bg-transparent w-full min-w-0">
      <Link href="/">
        <Image src="/images/newlogo.png" alt="logo" width={160} height={60} />
      </Link>
      <button onClick={toggleDrawer(true)} className="text-3xl">
        <MenuIcon />
      </button>
      <Drawer anchor="right" open={isDrawerOpen} onClose={toggleDrawer(false)} className="w-full">
        <div className="w-full">
          <div className="flex justify-between items-center px-4 py-4 bg-white shadow-md">
            <Link href="/">
              <Image src="/images/newlogo.png" alt="logo" width={160} height={60} />
            </Link>
            <button onClick={toggleDrawer(false)} className="text-3xl">
              <CloseIcon />
            </button>
          </div>
          <List>
            <ListItem disablePadding onClick={toggleDrawer(false)}>
              <Link href='/'>
                <ListItemButton>
                  <ListItemText primary="Home" />
                </ListItemButton>
              </Link>
            </ListItem>
            <Divider />
            <ListItem disablePadding>
              <ListItemButton onClick={() => IsOpen(!product)} >
                <ListItemText primary="Solutions" />
                <svg
                  className='mx-2'
                  width="12"
                  height="8"
                  viewBox="0 0 14 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.999999 1L7 7L13 1"
                    stroke='#3A3D46'
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </ListItemButton>
            </ListItem>
            <Divider />
            {product ?
              <motion.div
                initial="hidden"
                animate="visible"
                variants={{
                  visible: {
                    transition: {
                      staggerChildren: 0.1,
                    },
                  },
                }}
              >

                <div className="px-4">
                  <Link href='/solutions'>
                    <ListItemText primary="Solutions" />
                  </Link>
                  <p className="font-bold text-[#168def] text-sm mb-0 mt-2">Management</p>
                  {[
                    { name: "Staff management", href: "/solutions/staff-management" },
                    { name: "Vendor management", href: "/solutions/vendor-management" },
                    { name: "Task management", href: "/solutions/task-management" },
                    { name: "Manage Insufficiency", href: "/solutions/manage-insufficiency" },

                  ].map((item, i) => (
                    <motion.div key={item.href} custom={i} variants={linkVariants}>
                      <Link href={item.href}
                        onClick={toggleDrawer(false)}>{item.name}
                      </Link>
                    </motion.div>
                  ))}
                </div>
                {/* <div className="px-4 mb-2">
                  <p className="font-bold text-[#168def] text-sm mb-0 mt-2">VERIFY</p>
                  {[
                    { name: "Employment & Education Checks", href: "/checks/employment-education-checks" },
                    { name: "Criminal & Database Checks", href: "/checks/criminal-database" },
                    { name: "Identity & Address Checks", href: "/checks/Identity-address-checks" },
                    { name: "Media Checks", href: "/checks/media-checks" },
                    { name: "Health Checks", href: "/checks/health-checks" },
                    { name: "Other Checks", href: "/checks/other-checks" },
                    { name: "Credit Check", href: "/checks/credit-checks" },
                    { name: "Due Diligence", href: "/checks/due-diligence" },
                  ].map((item, i) => (
                    <motion.div key={item.href} custom={i + 3} variants={linkVariants}>
                      <Link href={item?.href}
                        onClick={toggleDrawer(false)}>{item?.name}
                      </Link>
                    </motion.div>
                  ))}
                </div>
                <div className="px-4 mb-2">
                  <p className="font-bold text-[#168def] text-sm mb-0 mt-2">Employee Screening</p>
                  {[
                    { name: "White Collar Verification", href: "/screening/white-collar" },
                    { name: "Blue Collar Verification", href: "/screening/blue-collar" },
                    { name: "Leadership Verification", href: "/screening/leadership" },
                    { name: "Moonlighting", href: "/screening/moonlighting" },
                    { name: "Gig Worker Verification", href: "/screening/gig-worker" },
                    { name: "Drug and Pre-Employment Health Checkups", href: "/screening/drug-&-pre-employment-health" },
                  ].map((item, i) => (
                    <motion.div key={item.href} custom={i + 3} variants={linkVariants}>
                      <Link href={item?.href}
                        onClick={toggleDrawer(false)}>{item?.name}
                      </Link>
                    </motion.div>
                  ))}
                </div> */}
                <div className="px-4 mb-2">
                  <p className="font-bold text-[#168def] text-sm mb-0 mt-2">Others</p>
                  {[
                    { name: "Digital Address Verification", href: "/solutions/digital-address-verification" },
                    { name: "Advanced Verification Technology", href: "/solutions/advanced-verification-technology" },
                    { name: "End-to-End Encryption", href: "/solutions/end-to-end-encryption" },
                    { name: "Payment Invoicing Integration", href: "/solutions/payment-invoicing-integration" },
                    // { name: "Video KYC", href: "/solutions/video-kyc" },
                    { name: "HRMS Integration", href: "/solutions/hrms-integration" },
                    { name: "Field Executive Mobile App", href: "/solutions/FE-mobile-app" },
                    { name: "Security And Compliance", href: "/solutions/security-and-compliance" },
                    { name: "Residence Verification", href: "/solutions/residence-verification" },
                  ].map((item, i) => (
                    <motion.div key={item.href} custom={i + 3} variants={linkVariants}>
                      <Link href={item?.href}
                        onClick={toggleDrawer(false)}>{item?.name}
                      </Link>
                    </motion.div>
                  ))}
                </div>
                <div className="px-4 mb-4 mt-2">
                  <Link
                    href="/solutions"
                    onClick={toggleDrawer(false)}
                    className="font-medium text-[#168def] text-[14px] border border-[#168def] bg-[#EEF7FF] hover:bg-[#168def] hover:text-white rounded-md px-4 py-[8px] transition-colors duration-200 block text-center"
                  >
                    Explore All Solutions
                  </Link>
                </div>
              </motion.div>
              : <></>}

            <Divider />
            <ListItem disablePadding>
              <ListItemButton onClick={() => setDropApi(!ApiDrop)} >
                <ListItemText primary="APIs" />
                <svg
                  className='mx-2'
                  width="12"
                  height="8"
                  viewBox="0 0 14 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.999999 1L7 7L13 1"
                    stroke='#3A3D46'
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </ListItemButton>
            </ListItem>
            <Divider />
            {ApiDrop ?
              <motion.div
                initial="hidden"
                animate="visible"
                variants={{
                  visible: {
                    transition: {
                      staggerChildren: 0.1,
                    },
                  },
                }}
              >

                <div className="px-4">
                  <Link href='/apis'>
                    <ListItemText primary="APIs" />
                  </Link>
                  <p className="font-bold text-[#168def] text-sm mb-0 mt-2">Identity</p>
                  {[
                    { name: "Aadhar Verification ", href: "/apis/aadhaar-verification" },
                    { name: "Driving License Verification", href: "/apis/driving-license-verification" },
                    { name: "Voter ID Verification", href: "/apis/voterID-verification" },
                    { name: "Passport Verification", href: "/apis/passport-verification" },

                  ].map((item, i) => (
                    <motion.div key={item.href} custom={i} variants={linkVariants}>
                      <Link href={item.href}
                        onClick={toggleDrawer(false)}>{item.name}
                      </Link>
                    </motion.div>
                  ))}
                </div>
                <div className="px-4 mb-2">
                  <p className="font-bold text-[#168def] text-sm mb-0 mt-2">Business</p>
                  {[
                    { name: "GSTIN Verification", href: "/apis/GSTIN-verification" },
                    { name: "Company Verification", href: "/apis/company-verification" },
                    { name: "Bank Account Verification", href: "/apis/bank-account-verification" },
                    { name: "MSME Verification", href: "/apis/MSME-verification" },
                  ].map((item, i) => (
                    <motion.div key={item.href} custom={i + 3} variants={linkVariants}>
                      <Link href={item?.href}
                        onClick={toggleDrawer(false)}>{item?.name}
                      </Link>
                    </motion.div>
                  ))}
                </div>
                <div className="px-4 mb-2">
                  <p className="font-bold text-[#168def] text-sm mb-0 mt-2">Asset</p>
                  {[
                    { name: "Vehicle RC Verification", href: "/apis/vehicle-verification" },
                    { name: "FSSAI License Verification", href: "/apis/FSSAI-verification" },
                    { name: "UAN Verification", href: "/apis/uan-verification" },
                    { name: "Court Record", href: "/apis/court-record" },
                  ].map((item, i) => (
                    <motion.div key={item.href} custom={i + 3} variants={linkVariants}>
                      <Link href={item?.href}
                        onClick={toggleDrawer(false)}>{item?.name}
                      </Link>
                    </motion.div>
                  ))}
                </div>
                <div className="px-4 mb-4 mt-2">
                  <Link
                    href="/apis"
                    onClick={toggleDrawer(false)}
                    className="font-medium text-[#168def] text-[14px] border border-[#168def] bg-[#EEF7FF] hover:bg-[#168def] hover:text-white rounded-md px-4 py-[8px] transition-colors duration-200 block text-center"
                  >
                    Explore All APIs
                  </Link>
                </div>
              </motion.div>
              : <></>}
            <Divider />
            {/* Industries Section */}
            <ListItem disablePadding>
              <ListItemButton onClick={() => setIndustriesDrop(!industriesDrop)} >
                <ListItemText primary="Industries" />
                <svg
                  className='mx-2'
                  width="12"
                  height="8"
                  viewBox="0 0 14 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.999999 1L7 7L13 1"
                    stroke='#3A3D46'
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </ListItemButton>
            </ListItem>
            <Divider />
            {industriesDrop ?
              <motion.div
                initial="hidden"
                animate="visible"
                variants={{
                  visible: {
                    transition: {
                      staggerChildren: 0.1,
                    },
                  },
                }}
              >
                <div className="px-4 mb-2">
                  <p className="font-bold text-[#168def] text-sm mb-0 mt-2">Fintech & BFSI</p>
                  {[
                    { name: "NBFC Verification", href: "/industries/nbfc-verification" },
                    { name: "Banking Verification", href: "/industries/banking-verification" },
                    { name: "Digital Lending", href: "/industries/digital-lending-verification" },
                    { name: "Fintech Platforms", href: "/industries/fintech-verification" },
                    { name: "Insurance Companies", href: "/industries/insurance-verification" },
                    { name: "Payment Gateways", href: "/industries/payment-gateway-verification" },
                  ].map((item, i) => (
                    <motion.div key={item.href} custom={i} variants={linkVariants}>
                      <Link href={item.href} onClick={toggleDrawer(false)}>{item.name}</Link>
                    </motion.div>
                  ))}
                  <p className="font-bold text-[#168def] text-sm mb-0 mt-3">HR & Workforce</p>
                  {[
                    { name: "Staffing Agencies", href: "/industries/staffing-agency-verification" },
                    { name: "Recruitment Agencies", href: "/industries/recruitment-agency-verification" },
                    { name: "HR Tech Platforms", href: "/industries/hr-tech-verification" },
                    { name: "Enterprises", href: "/industries/enterprise-verification" },
                    { name: "Gig Economy", href: "/industries/gig-economy-verification" },
                    { name: "Freelance Platforms", href: "/industries/freelancer-verification" },
                  ].map((item, i) => (
                    <motion.div key={item.href} custom={i} variants={linkVariants}>
                      <Link href={item.href} onClick={toggleDrawer(false)}>{item.name}</Link>
                    </motion.div>
                  ))}
                  <p className="font-bold text-[#168def] text-sm mb-0 mt-3">Logistics & Mobility</p>
                  {[
                    { name: "Logistics Companies", href: "/industries/logistics-verification" },
                    { name: "Fleet Management", href: "/industries/fleet-verification" },
                    { name: "Delivery Platforms", href: "/industries/delivery-platform-verification" },
                    { name: "Ride-Sharing Apps", href: "/industries/rideshare-verification" },
                  ].map((item, i) => (
                    <motion.div key={item.href} custom={i} variants={linkVariants}>
                      <Link href={item.href} onClick={toggleDrawer(false)}>{item.name}</Link>
                    </motion.div>
                  ))}
                  <p className="font-bold text-[#168def] text-sm mb-0 mt-3">Retail & Vendor</p>
                  {[
                    { name: "E-commerce", href: "/industries/ecommerce-verification" },
                    { name: "Marketplace Platforms", href: "/industries/marketplace-verification" },
                    { name: "B2B Marketplaces", href: "/industries/b2b-marketplace-verification" },
                    { name: "Vendor Onboarding", href: "/industries/vendor-onboarding-verification" },
                  ].map((item, i) => (
                    <motion.div key={item.href} custom={i} variants={linkVariants}>
                      <Link href={item.href} onClick={toggleDrawer(false)}>{item.name}</Link>
                    </motion.div>
                  ))}
                  <p className="font-bold text-[#168def] text-sm mb-0 mt-3">Healthcare & Others</p>
                  {[
                    { name: "Hospitals", href: "/industries/hospital-verification" },
                    { name: "Telemedicine", href: "/industries/telemedicine-verification" },
                    { name: "Healthcare Staffing", href: "/industries/healthcare-staffing-verification" },
                    { name: "EdTech Platforms", href: "/industries/edtech-verification" },
                    { name: "Education", href: "/industries/education-verification" },
                    { name: "Real Estate", href: "/industries/real-estate-verification" },
                    { name: "Rental Platforms", href: "/industries/rental-platform-verification" },
                    { name: "Legal Firms", href: "/industries/legal-verification" },
                    { name: "Consulting Firms", href: "/industries/consulting-verification" },
                    { name: "Govt Contractors", href: "/industries/government-verification" },
                  ].map((item, i) => (
                    <motion.div key={item.href} custom={i} variants={linkVariants}>
                      <Link href={item.href} onClick={toggleDrawer(false)}>{item.name}</Link>
                    </motion.div>
                  ))}
                </div>
              </motion.div>
              : <></>}
            <Divider />
            <ListItem disablePadding>
              <ListItemButton onClick={() => setProductsDrop(!products)} >
                <ListItemText primary="Products" />
                <svg
                  className='mx-2'
                  width="12"
                  height="8"
                  viewBox="0 0 14 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.999999 1L7 7L13 1"
                    stroke='#3A3D46'
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </ListItemButton>
            </ListItem>
            <Divider />
            {products ?
              <motion.div
                initial="hidden"
                animate="visible"
                variants={{
                  visible: {
                    transition: {
                      staggerChildren: 0.1,
                    },
                  },
                }}
              >

                <div className="px-4">
                  <p className="font-bold text-[#168def] text-sm mb-0 mt-2">Products</p>
                  {[
                    { name: "VerifyX", href: "/products/verifyx" },
                    { name: "API Product", href: "/apis" },
                    // { name: "Ally", href: "/help-center-for-vendor" },
                    // { name: "Block Certify", href: "/products/blockcertify" },

                  ].map((item, i) => (
                    <motion.div key={item.href} custom={i} variants={linkVariants}>
                      <Link href={item.href}
                        onClick={toggleDrawer(false)}>{item.name}
                      </Link>
                    </motion.div>
                  ))}
                </div>
              </motion.div>
              : <></>}
            <Divider />
            <ListItem disablePadding>
              <ListItemButton onClick={() => setUseCasesDrop(!useCasesDrop)} >
                <ListItemText primary="Use Cases" />
                <svg
                  className='mx-2'
                  width="12"
                  height="8"
                  viewBox="0 0 14 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.999999 1L7 7L13 1"
                    stroke='#3A3D46'
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </ListItemButton>
            </ListItem>
            <Divider />
            {useCasesDrop ?
              <motion.div
                initial="hidden"
                animate="visible"
                variants={{
                  visible: {
                    transition: {
                      staggerChildren: 0.1,
                    },
                  },
                }}
              >
                <div className="px-4 mb-2">
                  <p className="font-bold text-[#168def] text-sm mb-0 mt-2">Use Cases</p>
                  {[
                    { name: "Employee Onboarding Verification", href: "/use-cases/employee-onboarding-verification" },
                    { name: "Vendor Onboarding Verification", href: "/use-cases/vendor-onboarding-verification" },
                    { name: "Customer Onboarding Verification", href: "/use-cases/customer-onboarding-verification" },
                    { name: "Remote Hiring Verification", href: "/use-cases/remote-hiring-verification" },
                    { name: "API Based Verification", href: "/use-cases/api-based-verification" },
                    { name: "Fraud Prevention", href: "/use-cases/fraud-prevention" },
                    { name: "Digital KYC For Loan Companies", href: "/use-cases/digital-kyc-loan-companies" },
                  ].map((item, i) => (
                    <motion.div key={item.href} custom={i} variants={linkVariants}>
                      <Link href={item.href}
                        onClick={toggleDrawer(false)}>{item.name}
                      </Link>
                    </motion.div>
                  ))}
                </div>
              </motion.div>
              : <></>}
            <Divider />
            <ListItem
              onClick={toggleDrawer(false)}
              disablePadding
            >
            </ListItem>
            <Divider />
            <ListItem
              onClick={toggleDrawer(false)}
              disablePadding
            >
              <Link href='/partners'>
                <ListItemButton>
                  <ListItemText primary="Partner" />
                </ListItemButton>
              </Link>
            </ListItem>
            <Divider />
            <ListItem
              onClick={toggleDrawer(false)}
              disablePadding
            >
              <Link href='/blog'>
                <ListItemButton>
                  <ListItemText primary="Blog" />
                </ListItemButton>
              </Link>
            </ListItem>
            {/* <Divider />
            <ListItem
              onClick={toggleDrawer(false)}
              disablePadding
            >
              <Link href='/pricing'>
                <ListItemButton>
                  <ListItemText primary="Pricing" />
                </ListItemButton>
              </Link>
            </ListItem> */}
            <Divider />
            <ListItem
              onClick={toggleDrawer(false)}
              disablePadding
            >
              <Link href='/about-us'>
                <ListItemButton>
                  <ListItemText primary="About Us" />
                </ListItemButton>
              </Link>
            </ListItem>
            <Divider />
          </List>
        </div>
      </Drawer>
    </div>
  );
};

export default MobileHeader;
